import { getStudentUserData } from 'approot/shared/api/auth/student-user-auth';

export function isStudentAuthenticated() {
  const studentUser = getStudentUserData();
  return !!studentUser;
}
